export enum WoundMeasurementChannel {
  CREATE = 'woundMeasurement::create',
  EDIT = 'woundMeasurement::patch',
  DELETE = 'woundMeasurement::delete',
}
